"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = Object.freeze({
  tick: "\u2713\uFE0E",
  // 10003, // '\u2713',
  cross: "\u274C\uFE0E",
  // '\u274C',
  pause: "\u2223\u2223\uFE0E",
  // '\u23F8', // 9208, // '\u23F8',
  clockwise: "\uD83D\uDD01\uFE0E",
  // 10227, // '\u27F3'
  link: "\uD83D\uDD17\uFE0E",
  editable: "\u270E\uFE0E",
  // '\uD83D\uDD89',
  save: "\uD83D\uDCBE\uFE0E",
  left: "\u2039\uFE0E",
  right: "\u203A\uFE0E",
  up: "\u2303\uFE0E",
  down: "\u2304\uFE0E",
  settings: "\u2699\uFE0E",
  calendar: "\uD83D\uDCC5\uFE0E",
  info: "\uD83D\uDEC8\uFE0E"
});